/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { useTheme } from "@mui/material/styles";

// Framer Motion
import { motion } from "framer-motion";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Presentation page sections
import Counters from "pages/Presentation/sections/Counters";
import Information from "pages/Presentation/sections/Information";
import DesignBlocks from "pages/Presentation/sections/DesignBlocks";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/inicio.jpg";

function Presentation() {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <MKBox bgColor="#1158c28a">
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/pages/landing-pages/contact-us",
          label: "contáctanos",
          color: "info",
        }}
        sticky
      />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: isDarkMode
            ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${bgImage})`
            : `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKBox
              sx={{
                backgroundColor: isDarkMode ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.5)",
                backdropFilter: "blur(8px)",
                borderRadius: 2,
                py: 1.5,
                px: 2,
                display: "inline-block",
                textAlign: "center",
              }}
            >
              <MKTypography
                variant="h1"
                color={isDarkMode ? "white" : "dark"}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                Impresia S.A. de C.V.{" "}
              </MKTypography>
              <MKTypography
                variant="body1"
                color={isDarkMode ? "white" : "dark"}
                textAlign="center"
              >
                Soluciones integrales de papelería, tintas y servicios de impresión en el norte de
                México. Calidad e innovación desde 2008.
              </MKTypography>
            </MKBox>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white, background, mode }, functions: { rgba } }) =>
            rgba(mode === "dark" ? background.paper : white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Counters />
        <MKBox sx={{ my: 6, display: "flex", justifyContent: "center" }}>
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "60%" }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{ height: "3px", background: "linear-gradient(90deg, #1A73E8, #4FC3F7)" }}
          />
        </MKBox>
        <Information />
        <MKBox sx={{ my: 6, display: "flex", justifyContent: "center" }}>
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "60%" }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{ height: "3px", background: "linear-gradient(90deg, #1A73E8, #4FC3F7)" }}
          />
        </MKBox>
        <DesignBlocks />
        <MKBox sx={{ my: 6, display: "flex", justifyContent: "center" }}>
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "60%" }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{ height: "3px", background: "linear-gradient(90deg, #1A73E8, #4FC3F7)" }}
          />
        </MKBox>

        <MKBox pt={18} pb={6}>
          <Container>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={5} ml="auto" sx={{ textAlign: { xs: "center", lg: "left" } }}>
                <MKTypography
                  variant="h4"
                  fontWeight="bold"
                  mb={0.5}
                  color={isDarkMode ? "white" : "dark"}
                >
                  ¿Listo para trabajar con nosotros?
                </MKTypography>
                <MKTypography variant="body1" color={isDarkMode ? "white" : "text"}>
                  Contáctanos para una cotización personalizada.
                </MKTypography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={5}
                my={{ xs: 5, lg: "auto" }}
                mr={{ xs: 0, lg: "auto" }}
                sx={{ textAlign: { xs: "center", lg: "right" } }}
              >
                {/* Socials removed or updated later */}
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </MKBox>
  );
}

export default Presentation;
